// A discagem manual (/phone) é um recurso que a marca liga em Configurações ›
// Discador (PUT /v1/sip/manual-dial). Desligada, a tela só saberia recusar: o
// POST /v1/calls sem leadId responde manual_dial_disabled. Por isso a navegação
// (sidebar e drawer mobile) só mostra o item com o toggle ligado — mesmo
// desenho do gate de click-to-call (ver lib/click-to-call-enabled.ts).
//
// A chave de cache é a MESMA que as telas usam (`sipKeys.manualDial`), então
// ligar o toggle em Configurações já reflete no menu sem um GET novo: a tela
// grava a resposta do PUT no cache (useSetManualDial).
import { useQuery } from "@organizacaox/lai-design-system/query";
import { getManualDial } from "@/api/sip";
import { sipKeys } from "@/hooks/use-sip";

// Sem gate de papel, de propósito: a leitura do toggle é aberta a qualquer
// membro no back (GET /v1/sip/manual-dial), e quem mais precisa do item é o
// vendedor. Enquanto carrega — ou se o GET falhar — o resultado é `false`: o
// item só aparece com confirmação.
export function useManualDialEnabled(): boolean {
  const q = useQuery({
    queryKey: sipKeys.manualDial,
    queryFn: () => getManualDial(),
    retry: false,
  });
  return q.data?.manualDialEnabled ?? false;
}
